import React, { useEffect,  useState } from "react";

import Cookies from "js-cookie";
import { useDispatch, useSelector } from "react-redux";
import { Col, Row, Offcanvas, Button } from "react-bootstrap";
import PayRollFilterBox from "../../../components/FilterBox/PayRollFilter/PayRollFilter";
import { FiMenu } from "react-icons/fi";
import PayRollTable from "../../../components/Tables/PayRollTable";
import {
  SalaryDeductSumm,
  DeptList,
  SalaryDeductSummFun,
} from "../../../Redux/Slice/PayRoll/PayRollSlice";
import { Loader } from "../../../components/Loader/Loader";
import { useTheme } from "../../../Themecontext/Themecontext";

export const ESIStatement = () => {
  const dispatch = useDispatch();
  const { Colourdata, DataMain } = useSelector((state) => state.ClientLogin);
  const { SalaryDeductSummdata } = useSelector((state) => state.PayRollSlice);

  const iscolour = Colourdata?.data?.find((el) => el.ExeName === "NEWPAYROLL");
  const iscolourDark = Colourdata?.data?.find(
    (el) => el.ExeName === "NEWPAYROLLDARK",
  );

  const { theme } = useTheme();
  const isdark = theme;
  const Firm = Cookies.get("Firm");
  let YearId = Cookies.get("FinancialYear");

  useEffect(() => {
    dispatch(SalaryDeductSummFun());

    dispatch(
      DeptList({
        Firm: Firm,
        Year: YearId,
      }),
    );

    dispatch(
      SalaryDeductSumm({
        Firm: Firm,
        Year: YearId,
      }),
    );
  }, [dispatch, Firm, YearId]);

  // ✅ FILTER STATES
  const [filters, setFilters] = useState({
    year: [],
    month: [],
  });
  const [search, setSearch] = useState({
    year: "",
    month: "",
  });

  const [showFilter, setShowFilter] = useState(false);

  const toggleItem = (type, item) => {
    setFilters((prev) => {
      const selected = prev[type];

      return {
        ...prev,
        [type]: selected.includes(item.value)
          ? selected.filter((i) => i !== item.value)
          : [...selected, item.value],
      };
    });
  };
  const selectAll = (type, items) => {
    const allIds = items.map((i) => i.value);

    setFilters((prev) => ({
      ...prev,
      [type]: prev[type].length === items.length ? [] : allIds,
    }));
  };
  const handleSearch = (type, value) => {
    setSearch((prev) => ({
      ...prev,
      [type]: value,
    }));
  };

  // ✅ FILTER DATA
  const monthOptions = [
    { id: 4, month: "April" },
    { id: 5, month: "May" },
    { id: 6, month: "June" },
    { id: 7, month: "July" },
    { id: 8, month: "August" },
    { id: 9, month: "September" },
    { id: 10, month: "October" },
    { id: 11, month: "November" },
    { id: 12, month: "December" },
    { id: 1, month: "January" },
    { id: 2, month: "February" },
    { id: 3, month: "March" },
  ];

  const yearList =
    DataMain?.AC_Year_List?.map((item) => ({
      label: item?.AcYear,
      value: item?.AcYearID,
    })) || [];
  const monthList =
    monthOptions?.map((item) => ({
      label: item?.month,
      value: item?.id,
    })) || [];

  const getRows = SalaryDeductSummdata?.ESISumm?.map((label, index) => ({
    // srNumber: index + 1,
    ESIamt: label.ESIamt,
    EmplName: label.EmplName,
    EsiNo: label.EsiNo,
  }));

  const getColumns = [
    {
      key: "srNumber",
      label: "Sr. No.",
      align: "center",
      colors: isdark === "light" ? "#000" : "#fff",
    },
    {
      key: "EmplName",
      label: "Employee",
      align: "left",
      colors: isdark === "light" ? "#000" : "#fff",
    },
    { key: "EsiNo", label: "ESI Number", align: "right" },
    { key: "ESIamt", label: "ESI Amount", align: "right", format: "true" },
  ];

  const applyFilters = () => {
    dispatch(SalaryDeductSummFun());

    const finalYearIDs =
      filters.year.length > 0 ? filters.year : [Cookies.get("FinancialYear")];

    dispatch(
      SalaryDeductSumm({
        Firm: Firm,
        Year: finalYearIDs.join(","),
        MonthIDs: filters.month.join(","),
      }),
    );
  };
  if (!SalaryDeductSummdata) {
    return (
      <div
        style={{
          height: "100vh",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <Loader />
      </div>
    );
  }

  if (SalaryDeductSummdata === null || SalaryDeductSummdata === "no") {
    return (
      <div
        style={{
          height: "100vh",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <Loader />
      </div>
    );
  }

  return (
    <div
      style={{
        padding: "16px",
        background:
          isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour2,
        minHeight: "100vh",
      }}
    >
      {/* MOBILE FILTER */}
      <div className="d-lg-none d-flex justify-content-end mb-3">
        <Button
          onClick={() => setShowFilter(true)}
          style={{
            backgroundColor:
              isdark === "light" ? iscolour?.Colour6 : iscolourDark?.Colour7,
            color:
              isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour12,
            border: "none",
            borderRadius: "10px",
            padding: "8px 12px",
            boxShadow: "0 4px 10px rgba(0,0,0,0.18)",
          }}
        >
          <FiMenu size={22} />
        </Button>
      </div>

      {/* OFFCANVAS */}
      <Offcanvas
        show={showFilter}
        onHide={() => setShowFilter(false)}
        style={{
          background:
            isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour2,
        }}
      >
        <Offcanvas.Header
          closeButton
          closeVariant={isdark === "dark" ? "white" : undefined}
        >
          <Offcanvas.Title
            style={{
              color:
                isdark === "light"
                  ? iscolour?.Colour12
                  : iscolourDark?.Colour12,
            }}
          >
            Filters
          </Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body>
          <div
            style={{ display: "flex", flexDirection: "column", gap: "20px" }}
          >
            <PayRollFilterBox
              title="Year"
              items={yearList}
              search={search.year}
              setSearch={(val) => handleSearch("year", val)}
              selectedItems={filters.year}
              toggleItem={(item) => toggleItem("year", item)}
              selectAll={() => selectAll("year", yearList)}
            />

            <PayRollFilterBox
              title="Month"
              items={monthList}
              search={search.month}
              setSearch={(val) => handleSearch("month", val)}
              selectedItems={filters.month}
              toggleItem={(item) => toggleItem("month", item)}
              selectAll={() => selectAll("month", monthList)}
            />
            <Button
              onClick={applyFilters}
              style={{
                width: "100%",
                // height: "44px",
                padding:"12px",
                borderRadius: "12px",
                backgroundColor:
                  isdark === "light"
                    ? iscolour?.Colour6
                    : iscolourDark?.Colour7,
                color:
                  isdark === "light"
                    ? iscolour?.Colour1
                    : iscolourDark?.Colour12,
                border: "none",
                fontWeight: "700",
              }}
              className="common-hover-btn"
            >
              Apply Filters
            </Button>
          </div>
        </Offcanvas.Body>
      </Offcanvas>

      <Row className="g-4">
        {/* FILTER */}
        <Col xl={3} lg={4} className="d-none d-lg-block">
          <div
            style={{ display: "flex", flexDirection: "column", gap: "20px" }}
          >
            <PayRollFilterBox
              title="Year"
              items={yearList}
              search={search.year}
              setSearch={(val) => handleSearch("year", val)}
              selectedItems={filters.year}
              toggleItem={(item) => toggleItem("year", item)}
              selectAll={() => selectAll("year", yearList)}
            />

            <PayRollFilterBox
              title="Month"
              items={monthList}
              search={search.month}
              setSearch={(val) => handleSearch("month", val)}
              selectedItems={filters.month}
              toggleItem={(item) => toggleItem("month", item)}
              selectAll={() => selectAll("month", monthList)}
            />
            <Button
              onClick={applyFilters}
              style={{
                width: "100%",
                // height: "44px",
                padding:"12px",
                borderRadius: "12px",
                backgroundColor:
                  isdark === "light"
                    ? iscolour?.Colour6
                    : iscolourDark?.Colour7,
                color:
                  isdark === "light"
                    ? iscolour?.Colour1
                    : iscolourDark?.Colour12,
                border: "none",
                fontWeight: "700",
              }}
              className="common-hover-btn"
            >
              Apply Filters
            </Button>
          </div>
        </Col>

        {/* TABLE */}
        <Col xl={9} lg={8}>
          <div
            style={{
              borderRadius: "12px",
              overflow: "hidden",
              boxShadow: "0 4px 10px rgba(0,0,0,0.2)",
            }}
          >
            <div
              style={{
                padding: "14px",
                background:
                  isdark === "light"
                    ? iscolour?.Colour6
                    : iscolourDark?.Colour7,
                color: "#fff",
                fontWeight: "600",
                fontSize: "18px",
                margin: 0,
                letterSpacing: "1px",
              }}
            >
              ESI STATEMENT
            </div>

            <PayRollTable
              columns={getColumns}
              data={getRows}
              showSearch={true}
            />
          </div>
        </Col>
      </Row>
    </div>
  );
};
